// Mock data for TYJ Group website

export const services = {
  development: [
    { id: 1, name: 'Responsive Design', icon: 'Layout' },
    { id: 2, name: 'React Web Development', icon: 'Code' },
    { id: 3, name: 'Android Apps Development', icon: 'Smartphone' },
    { id: 4, name: 'Laravel Web Development', icon: 'FileCode' },
    { id: 5, name: 'iOS Apps Development', icon: 'Apple' },
    { id: 6, name: 'UX/UI Design', icon: 'Palette' },
    { id: 7, name: 'E-Commerce Development', icon: 'ShoppingCart' },
    { id: 8, name: 'AI Platform Development', icon: 'Brain' }
  ],
  cloud: [
    { id: 1, name: 'Security Monitoring', icon: 'Shield' },
    { id: 2, name: 'Sharepoint', icon: 'Share2' },
    { id: 3, name: 'Web Hosting', icon: 'Globe' },
    { id: 4, name: 'Performance Optimization', icon: 'Zap' },
    { id: 5, name: 'Business Continuity', icon: 'TrendingUp' },
    { id: 6, name: 'Remote Support', icon: 'Headphones' },
    { id: 7, name: 'Email Servers', icon: 'Mail' },
    { id: 8, name: 'Cloud Infrastructure', icon: 'Cloud' }
  ],
  consulting: [
    { id: 1, name: 'Market Research Consultants' },
    { id: 2, name: 'B2B Market Research' },
    { id: 3, name: 'Qualitative Research' },
    { id: 4, name: 'B2B Market Consultants' },
    { id: 5, name: 'Customer Satisfaction' },
    { id: 6, name: 'International Research' },
    { id: 7, name: 'Market Segmentation' },
    { id: 8, name: 'Full Service Data/Analytics' },
    { id: 9, name: 'Brand Identity' },
    { id: 10, name: 'Research Design/Methodology' }
  ]
};

export const whyChooseUs = [
  {
    id: 1,
    title: 'Specialized in Digital Transformation',
    description: 'The main and the only focus of TYJ Group is Digital Transformation and Cyber Security or nothing else',
    icon: 'Zap'
  },
  {
    id: 2,
    title: 'Strong Research and Development (R&D)',
    description: 'TYJ Group R&D unit constantly conducts advanced research to update our current frameworks and techniques, provide applied best practices, and develop effective and creative models.',
    icon: 'FlaskConical'
  },
  {
    id: 3,
    title: 'Comprehensive project management',
    description: 'TYJ Group experienced management team has unique principles, methods, techniques and practices for managing system development projects of any size or complexity.',
    icon: 'FolderKanban'
  },
  {
    id: 4,
    title: 'Technical Leaders & Certified Experts',
    description: 'Our team is a well-matched combination of technical leaders who closely work with qualified experienced experts to successfully carry out projects.',
    icon: 'Award'
  },
  {
    id: 5,
    title: 'Proactive Client Support',
    description: 'We always make the first move to support our clients and minimize the cost and business impact.',
    icon: 'UserCheck'
  },
  {
    id: 6,
    title: 'Effective Communication',
    description: 'With aim of building a lasting relationship of trust, the TYJ Group team employ effective and active communication with clients during projects delivery, system handling and emergency cases.',
    icon: 'MessageSquare'
  }
];

export const clients = [
  { id: 1, name: 'AmBank', initials: 'AB' },
  { id: 2, name: 'Core Collective', initials: 'CC' },
  { id: 3, name: 'Tadaa', initials: 'TD' },
  { id: 4, name: 'AXA', initials: 'AXA' },
  { id: 5, name: 'RedOne', initials: 'R1' },
  { id: 6, name: 'CIMB', initials: 'CB' },
  { id: 7, name: 'Haidilao', initials: 'HL' },
  { id: 8, name: 'Razer', initials: 'RZ' },
  { id: 9, name: 'Fly', initials: 'FLY' },
  { id: 10, name: 'POS Malaysia', initials: 'POS' },
  { id: 11, name: 'Touch n Go', initials: 'TnG' },
  { id: 12, name: 'CookX', initials: 'CX' }
];

export const cloudPartners = [
  { id: 1, name: 'Alibaba Cloud', initials: 'AC' },
  { id: 2, name: 'AWS', initials: 'AWS' },
  { id: 3, name: 'Microsoft Azure', initials: 'MA' },
  { id: 4, name: 'Google Cloud', initials: 'GC' }
];
